<template>
    <div class="p-3">
        <h5 class="subtitle-2">
            Machship key
        </h5>
        <integrations-key-form
            ref="machshipKeyForm"
            :formItems="formItems"
            :remove="onRemove"
            :isMultiple="true"
            :is_disabled="is_disabled">
        </integrations-key-form>
        <div v-if="!is_disabled" class="mt-3 pb-3 pl-3 d-flex">
            <v-spacer></v-spacer>
            <v-btn small color="primary" :disabled="isSubmit" @click="onSubmit">
                <span v-if="isSubmit">
                    <v-progress-circular
                        indeterminate
                        size="12"
                        width="2"
                        color="green darken-3">
                    </v-progress-circular>
                    saving
                </span>
                <span v-else>save</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import IntegrationsKeyForm from './forms/IntegrationsKeyForm.vue'
// import moment from 'moment'

export default {
    props: {
        integrationId: { type: Number, default: null },
        integrationKeys: { type: Array, default: null },
        is_disabled: { type: Boolean, default: false },
        check_test_mode: { type: String, default: 'inactive' }
    },

    components: {
        IntegrationsKeyForm
    },

    data() {
        return {
            // machship key form
            formItems: null,
            checkMode: null,
            isSubmit: false,
        }
    },

    created() {
        this.initKeys(this.integrationKeys);
    },


    methods: {

        initKeys(keys) {
            let integrationId = this.integrationId ? this.integrationId : this.$route.params.id;

            // make sure we only displaying machship here
            this.formItems = keys.filter(item => {
                return item.key_type.indexOf('machship') >= 0
            });

            // if there are no machship set by default we display an empty field
            if (this.formItems.length <= 0) {
                this.formItems = [{
                    integration_id: integrationId,
                    key_type: 'machship_token',
                    key_data: '',
                    expiry: '',
                    showDate: false,
                }];
            }


            // if test machship token isn't found, we add it manually by default
            let index = this.formItems.findIndex(key => key.key_type === 'test_machship_token')
            if (index == -1) {
                this.formItems.push({
                    integration_id: integrationId,
                    key_type: 'test_machship_token',
                    key_data: '',
                    expiry: '',
                    showDate: false,
                });
            }

            // let findAdminIndex = this.formItems.findIndex(key => key.key_type === 'admin_machship_token')
            // if (findAdminIndex == -1) {
            //     this.formItems.push({
            //         integration_id: integrationId,
            //         key_type: 'admin_machship_token',
            //         key_data: '',
            //         expiry: '',
            //         showDate: false
            //     });
            // }
        },

        onRemove() {
            alert("on remove machship token")
        },

        async onSubmit() {
            this.isSubmit = true
            let result = await this.$refs.machshipKeyForm.onKeyFormSubmit()

            if (result && result.data) {
                // once we get the result, we need to update our form data
                this.initKeys(result.data.attributes.keys);
            }

            this.isSubmit = false
        }
    }
}
</script>